(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];
  const money = (cents) => cents == null ? 'Price unavailable' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents) / 100);

  const closeDesktopMenus = (except = null) => {
    qsa('[data-ps-nav-item]').forEach((item) => {
      if (item === except) return;
      const button = qs(':scope > button[aria-controls]', item);
      const panel = button && document.getElementById(button.getAttribute('aria-controls'));
      if (button) button.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  };
  qsa('[data-ps-nav-item]').forEach((item) => {
    const button = qs(':scope > button[aria-controls]', item);
    const panel = button && document.getElementById(button.getAttribute('aria-controls'));
    if (!button || !panel) return;
    let clickedOpen = false;
    const open = () => { closeDesktopMenus(item); button.setAttribute('aria-expanded', 'true'); panel.hidden = false; };
    const close = () => { button.setAttribute('aria-expanded', 'false'); panel.hidden = true; };
    item.addEventListener('pointerenter', () => { clickedOpen = false; open(); });
    item.addEventListener('pointerleave', (event) => { if (!item.contains(event.relatedTarget)) { clickedOpen = false; close(); } });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (event) => { if (!item.contains(event.relatedTarget)) close(); });
    button.addEventListener('click', () => {
      if (clickedOpen) { clickedOpen = false; close(); }
      else { clickedOpen = true; open(); }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeDesktopMenus();
    closeMobileMenu();
    closeCart();
  });

  const mobileMenu = qs('[data-ps-mobile-menu]');
  const mobileOpen = qs('[data-ps-menu-open]');
  const closeMobileMenu = () => {
    if (!mobileMenu || !mobileOpen) return;
    mobileMenu.hidden = true;
    mobileOpen.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  };
  mobileOpen?.addEventListener('click', () => {
    mobileMenu.hidden = false;
    mobileOpen.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
    qs('button,[href],summary', mobileMenu)?.focus();
  });
  qsa('[data-ps-menu-close]').forEach((button) => button.addEventListener('click', closeMobileMenu));

  qsa('[data-ps-slideshow]').forEach((slideshow) => {
    const slides = qsa('[data-ps-slide]', slideshow);
    const buttons = qsa('[data-ps-slide-to]', slideshow);
    const show = (index) => {
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== index; slide.classList.toggle('is-active', slideIndex === index); });
      buttons.forEach((button, buttonIndex) => { button.classList.toggle('is-active', buttonIndex === index); button.setAttribute('aria-selected', String(buttonIndex === index)); });
    };
    buttons.forEach((button) => button.addEventListener('click', () => show(Number(button.dataset.psSlideTo))));
  });

  const drawer = qs('[data-ps-cart-drawer]');
  const drawerContent = qs('[data-ps-cart-drawer-content]');
  const openCart = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    qs('[data-ps-cart-close]', drawer)?.focus();
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  };
  qsa('[data-ps-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  qsa('[data-ps-cart-close]').forEach((button) => button.addEventListener('click', closeCart));

  const renderCart = (cart) => {
    qsa('[data-ps-cart-count]').forEach((node) => { node.textContent = String(cart.item_count || 0); });
    if (!drawerContent) return;
    if (!cart.items?.length) {
      drawerContent.innerHTML = '<p>Your cart is empty.</p>';
      return;
    }
    drawerContent.innerHTML = cart.items.map((item) => `<div class="ps-cart-drawer__item"><a href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a><div><a href="${item.url}">${item.product_title}</a><p>${item.variant_title || ''}</p><p>Qty ${item.quantity} · ${money(item.final_line_price)}</p></div></div>`).join('');
  };
  const addToCart = async (form) => {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Unable to add this item.');
    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Unable to refresh the cart.');
    const cart = await cartResponse.json();
    renderCart(cart);
    openCart();
  };
  qsa('[data-ps-quick-add],[data-ps-product-form]:not([data-ps-external-customization])').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = qs('button[type="submit"]', form);
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try { await addToCart(form); }
    catch (error) { window.alert(error.message); }
    finally { if (button) { button.disabled = false; button.textContent = original; } }
  }));

  qsa('[data-ps-quantity]').forEach((wrapper) => {
    const input = qs('input[type="number"]', wrapper);
    qs('[data-ps-quantity-minus]', wrapper)?.addEventListener('click', () => { input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1)); input.dispatchEvent(new Event('change', { bubbles: true })); });
    qs('[data-ps-quantity-plus]', wrapper)?.addEventListener('click', () => { input.value = String(Number(input.value || 1) + 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  qsa('[data-ps-product]').forEach((root) => {
    const data = qs('[data-ps-product-json]', root);
    if (!data) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch { return; }
    const form = qs('[data-ps-product-form]', root);
    if (!form) return;
    const pick = () => {
      const selected = [1, 2, 3].map((position) => qs(`input[name="option${position}"]:checked`, form)?.value).filter((value) => value != null);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      qs('[data-ps-variant-id]', form).value = variant.id;
      qsa('[data-ps-option-label]', form).forEach((label, index) => { label.textContent = selected[index] || ''; });
      const price = qs('[data-ps-price]', root); if (price) price.textContent = money(variant.price);
      const compare = qs('[data-ps-compare-price]', root); if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = compare.hidden ? '' : money(variant.compare_at_price); }
      qsa('[data-ps-sku],[data-ps-detail-sku]', root).forEach((node) => { node.textContent = variant.sku || ''; });
      const add = qs('[data-ps-add-to-cart]', form); if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'Add to shopping bag' : 'Sold out'; }
      if (variant.featured_image?.src) { const image = qs('[data-ps-main-image]', root); if (image) { image.src = variant.featured_image.src; image.removeAttribute('srcset'); } }
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    };
    qsa('.ps-option input', form).forEach((input) => input.addEventListener('change', pick));
  });
  qsa('[data-ps-thumb]').forEach((button) => button.addEventListener('click', () => { const image = qs('[data-ps-main-image]', button.closest('[data-ps-product]')); if (image) { image.src = button.dataset.imageSrc; image.removeAttribute('srcset'); } }));

  qs('[data-ps-filter-toggle]')?.addEventListener('click', (event) => {
    const target = document.getElementById(event.currentTarget.getAttribute('aria-controls'));
    const open = !target.classList.contains('is-open');
    target.classList.toggle('is-open', open);
    event.currentTarget.setAttribute('aria-expanded', String(open));
  });
  const sort = qs('[data-ps-sort]');
  if (sort) {
    const current = new URL(window.location.href).searchParams.get('sort_by'); if (current) sort.value = current;
    sort.addEventListener('change', () => { const url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); window.location.assign(url); });
  }

  const updateCartLine = async (article, quantity) => {
    const line = Number(article.dataset.line);
    const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    if (!response.ok) throw new Error('Unable to update the cart.');
    window.location.reload();
  };
  qsa('[data-line]').forEach((article) => {
    const input = qs('input[type="number"]', article);
    qs('[data-ps-cart-minus]', article)?.addEventListener('click', () => updateCartLine(article, Math.max(0, Number(input.value) - 1)));
    qs('[data-ps-cart-plus]', article)?.addEventListener('click', () => updateCartLine(article, Number(input.value) + 1));
    qs('[data-ps-cart-remove]', article)?.addEventListener('click', () => updateCartLine(article, 0));
  });
})();
